import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppService } from "./app.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class MyfocusService {
	hardwareKey: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	constructor(public app: AppService, public venueService: OOVenueService) {}

	init() {
		this.hardwareKey.next(this.venueService.venueKey.toString());
	}
}
